<template>
  <div class="q-px-lg q-pb-md">
    <q-timeline color="secondary">
      <template
        v-for="({ order, year, title, date, icon, source }, i) in dateList"
        
      >
        <template v-if="source.value !== '' && source.value !== null">
          <q-timeline-entry v-if="isFirstOrNewYear(i)" heading tag="h4" :key="order">
            {{ year }}
          </q-timeline-entry>

          <q-timeline-entry :icon="icon" :class="`cal-entry-${i}`" :key="order">
            <h6 class="q-my-xs">
              {{ date }}
              <q-icon v-if="edit" name="event" class="cursor-pointer" />

              <q-icon
                v-if="edit"
                name="clear"
                class="cursor-pointer"
                @click.stop="source.value = ''"
              />
            </h6>

            <template v-slot:subtitle>
              {{ title }}

              <q-popup-proxy
                :target="`.cal-entry-${i}`"
                v-if="edit"
                @before-show="updateProxyDate(source)"
                transition-show="scale"
                transition-hide="scale"
                class="cursor-pointer"
              >
                <q-date
                  v-model="proxyDate"
                  mask="YYYY-MM-DD"
                  :options="d => dateOptions(dateList, i, d)"
                >
                  <div class="row items-center justify-end q-gutter-sm">
                    <q-btn label="Cancel" color="primary" flat v-close-popup />
                    <q-btn
                      label="OK"
                      color="primary"
                      flat
                      v-close-popup
                      @click="saveDate(dateList, i)"
                    />
                  </div>
                </q-date>
              </q-popup-proxy>
            </template>
          </q-timeline-entry>
        </template>

        <template v-if="source.value === '' || source.value === null">
          <q-timeline-entry dense  :icon="icon" :key="source">
            <template v-slot:subtitle>
              {{title}}
              <q-input
                :value="date"
                readonly
                :disable="!edit"
                v-if="edit"
                lazy-rules
                :rules="i <= requires ? [required] : []"
              >
                <template v-slot:append>
                  <q-icon name="event" class="cursor-pointer">
                    <q-popup-proxy
                      v-if="edit"
                      @before-show="updateProxyDate(source)"
                      transition-show="scale"
                      transition-hide="scale"
                    >
                      <q-date
                        v-model="proxyDate"
                        mask="YYYY-MM-DD"
                        :options="d => dateOptions(dateList, i, d)"
                        :rules="[required]"
                      >
                        <div class="row items-center justify-end q-gutter-sm">
                          <q-btn
                            label="Cancel"
                            color="primary"
                            flat
                            v-close-popup
                          />
                          <q-btn
                            label="OK"
                            color="primary"
                            flat
                            v-close-popup
                            @click="saveDate(dateList, i)"
                          />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
            </template>
          </q-timeline-entry>
        </template>
      </template>
    </q-timeline>
  </div>
</template>

<script setup>
import { date } from "quasar";
import { computed, ref, defineProps, defineEmits } from "vue";

const props = defineProps({
  modelValue: Array,
  edit: { type: Boolean },
  requires: {type: Number}
});

const emit = defineEmits(["update:modelValue"]);

const options = { month: "long", day: "2-digit" };
const DATE_MASK = "YYYY-MM-DD";
const formatDate = date =>
  new Date(`${date}T00:00:00`).toLocaleDateString("pt-BR", options);
const year = date => new Date(date).getFullYear();
const entryFromPosNameDateIcon = (order, title, date, icon) => ({
  order,
  title,
  year: year(date),
  date: formatDate(date),
  source: ref(date),
  icon
});

const proxyDate = ref("");
const dateList = computed(() =>
  props.modelValue.map(({ order, name, date, icon }) =>
    entryFromPosNameDateIcon(order, name, date, icon)
  )
);

const required = v => !!v || "Campo obrigatório";
const isFirstOrNewYear = i =>
  i == 0 || dateList.value[i - 1].year != dateList.value[i].year;
const updateProxyDate = v => (proxyDate.value = v.value);

const saveDate = (dateList, i) => {
  let entry = entryFromPosNameDateIcon(
    dateList[i].order,
    dateList[i].title,
    proxyDate.value,
    dateList[i].icon
  );
  dateList.splice(i, 1, entry);
  let proxy = [];
  proxy.push(...props.modelValue);
  proxy.splice(i, 1, {
    order: entry.order,
    name: entry.title,
    date: proxyDate.value,
    icon: entry.icon
  });
  emit("update:modelValue", proxy);
};
const dateOptions = (list, i, d) => {
  const previousDate = k =>
    list[k - 1].source.value !== "" && list[k - 1].source.value !== null
      ? list[k - 1].source.value
      : lastDate(k - 1);
  const lastDate = j => (j > 0 ? previousDate(j) : "1800-01-01");
  let lastSelected = lastDate(i);

  let today = date.formatDate(Date.now(), DATE_MASK);
  let diffFromToday = date.getDateDiff(today, d, "days");
  let isPast = diffFromToday >= -1;
  let diffFromLastSelected = date.getDateDiff(d, lastSelected, "days");
  let isAfterLastSelected = diffFromLastSelected > 0;

  return isPast && isAfterLastSelected;
};
</script>


<style lang="scss" >
@import "@/styles/quasar.variables.sass";
.q-timeline .q-timeline__subtitle {
  @extend h5 !optional;
  font-size: 14px;
}
.q-timeline__entry .q-timeline__heading-title {
  padding-bottom: 5px;
}
.q-timeline__entry .q-timeline__subtitle {
  margin-bottom: 0;
}
.q-timeline__entry .q-timeline__content {
  padding-bottom: 5px;
}
</style>
